import * as Config from '../../../../config';
import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useDrop } from 'react-dnd';
import { MenuItem } from "react-contextmenu";

import IconCheckout from '../svg/IconCheckout';
// import IconEdit from '../../svg/IconEdit';

import { initCartCounter, setCartItems } from "../redux/actions/index";
import useGetOne from '../../../../hooks/useGetOne';
import useCartStore from './useCartStore';
import { setContextMenu/*, setTouchEditor*/ } from "../../../../actions/index";

window.timers = [];

const useCartMenu = (refresh) => {
  const dispatch = useDispatch();
  const api = useSelector(state => state.api);
  const isConnected = useSelector(state => state.isConnected);
  const storePopup = useSelector(state => state.storePopup);

  const { addItemsToCart, showModalNoPurchasable/*, goToCart*/ } = useCartStore();
  const { item } = useGetOne(isConnected ? api : null, '/my/default-cart/', refresh);

  useEffect(() => {
    if (isConnected && refresh === null && item) {
      dispatch(initCartCounter(item.summary.item_count));
      dispatch(setCartItems(item.tracks.map( x => x.item_id)));
    }
  }, [dispatch, refresh, item, isConnected])

  const selectedItems = useSelector(state => state.selectedItems); // IMPORTANT
  const hasSelectedItems = (selectedItems.length > 0);

  const onDrop = () => {
    if (isConnected && hasSelectedItems && item && item.tracks) {
      let notPurchasables = selectedItems.filter(x => x.is_dj_edit);
      if (notPurchasables.length > 0) {
        showModalNoPurchasable();
      }
      let duplicated = selectedItems.filter( x => item.tracks.find(y => y.item_id === x.id) ).map( x => x.id);
      let items = selectedItems.filter(x => !x.is_dj_edit).filter( x => !duplicated.includes(x.id) ).map(x => x.id);
      addItemsToCart(items, duplicated, item.tracks.length);
    } else if (!isConnected) {
      storePopup.cart();
    }
  }

  const [{ el, canDrop, isOver }, refDrop] = useDrop({
    accept: ['TRACK', 'PLAYLIST', 'PLAYLIST-MENU', 'CHART', 'CHART-NAV', 'TRACK-CARD', 'RELEASE', 'DECK'],
    drop: onDrop,
    collect: (monitor) => ({
      el: monitor.getItem(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    }),
  })
  const availableDrop = (hasSelectedItems && canDrop && isOver);
  const opacity = (el && el.type === `CHART` && !hasSelectedItems) ? 0.2 : 1;

  // const edit = () => {
  //   dispatch(setTouchEditor(true));
  //   goToCart();
  // }
  const checkout = () => {
    window.open(`https://www.${Config.API_NAME}.com/cart/cart/${item.id}`, `_blank`);
  }

  const showContextMenu = () => {
    dispatch(setContextMenu([
      // <MenuItem key={`cart-edit`} onClick={edit} data={{ action: 'edit' }}>
      //   <div className={'flexRow block-contextmenu-item all-hover'}>
      //     <IconEdit />
      //     {`Edit Cart`}
      //   </div>
      // </MenuItem>,
      <MenuItem key={`cart-checkout`} onClick={checkout} data={{ action: 'checkout' }}>
        <div className={'flexRow block-contextmenu-item all-hover'}>
          <IconCheckout />
          {`View on ${Config.capAppName()}`}
        </div>
      </MenuItem>,
    ], {className: 'dynamic-menu-playlist-menu'}));
  }

  const storeX = {
    availableDrop,
    opacity,
    canDrop,
    isOver,
    refDrop,
    showContextMenu
  };

  return storeX;
};

export default useCartMenu;
